<template>
  <div class="home">
    <pcView v-if="isShowPc" />
    <h5View v-else />
  </div>
</template>

<script>
import pcView from "../components/pc";
import h5View from "../components/h5";

export default {
  name: "Home",
  components: {
    pcView,
    h5View,
  },
  data() {
    return {
      isShowPc: true 
    };
  },
  mounted() {
    var self = this;
    var winWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    var oHtml = document.getElementsByTagName("html")[0];
    // if (winWidth > 750) {
    //   self.isShowPc = false;
    // } else {
    //   self.isShowPc = true;
    //   oHtml.setAttribute(
    //     "style",
    //     `font-size: ${(100 * winWidth) / 1920}px !important;`
    //   );
    // } 

    if (winWidth > 750) {
      oHtml.setAttribute(
        "style",
        `font-size: ${(100 * winWidth) / 1920}px !important;`
      );
    } else {
      if (location.host == "www.angemo.net.cn") {
        return false;
      }
      var url = "https://m.twototwo.cn";
      if (location.href.indexOf("?") >= 0) {
        if (location.href.indexOf("distributorId") >= 0) {
          url = "https://m.twototwo.cn/pages/member/login";
        }
        url += location.href.substring(location.href.indexOf("?"));
      }
      location.href = url;
    }

    window.addEventListener("resize", function () {
      var winWidth =
        document.documentElement.offsetWidth || document.body.offsetWidth;

      if (winWidth > 750) {
        oHtml.setAttribute(
          "style",
          `font-size: ${(100 * winWidth) / 1920}px !important;`
        );
      } else {
        if (location.host == "www.angemo.net.cn") {
          return false;
        }
        var url = "https://m.twototwo.cn";
        if (location.href.indexOf("?") >= 0) {
          if (location.href.indexOf("distributorId") >= 0) {
            url = "https://m.twototwo.cn/pages/member/login";
          }
          url += location.href.substring(location.href.indexOf("?"));
        }
        location.href = url;
      }
    });

    // window.addEventListener("resize", function () {
    //   var winWidth =
    //     document.documentElement.offsetWidth || document.body.offsetWidth;
    //   if (winWidth <= 750) {
    //     self.isShowPc = false;
    //     oHtml.setAttribute("style", `font-size: ${(100 * winWidth) / 750}px;`);
    //   } else {
    //     self.isShowPc = true;
    //     oHtml.setAttribute(
    //       "style",
    //       `font-size: ${(100 * winWidth) / 1920}px !important;`
    //     );
    //   }
    // });
  },
};
</script>
